import React, {useState} from 'react'
import {Form, Modal} from 'react-bootstrap'
import {
  FaUpload,
  FaChevronDown,
  FaIdCard,
  FaUser,
  FaFileAlt,
  FaUserCheck,
  FaHospitalUser,
  FaBirthdayCake,
  FaVenusMars,
  FaBuilding,
  FaCalendarAlt,
  FaStickyNote,
  FaFile,
} from 'react-icons/fa'
import EnrollmentHistory from './EnrollmentHistory'
import './../style.css'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

interface ClaimDetails {
  claimDetails: any
}

interface PatientDetailsProps {
  claimDetails?: any
}

const PatientDetails: React.FC<PatientDetailsProps> = ({claimDetails}) => {
  const [isEditing, setIsEditing] = useState(false)
  const [showDocModal, setShowDocModal] = useState(false)

  const jsonString = claimDetails?.claimDetails?.memberDetail
  const parsedJson = jsonString ? JSON.parse(jsonString) : {}
  console.log('Parsed JSON:', parsedJson)

  const calculateAge = (dateOfBirth?: string): string => {
    if (!dateOfBirth) return ''
    const dob = new Date(dateOfBirth)
    const now = new Date()
    const age = now.getFullYear() - dob.getFullYear()
    return `${dob.toLocaleDateString('id-ID', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })} (${age} tahun)`
  }

  const handleEditClick = () => {
    setIsEditing(true)
  }

  const handleSaveClick = () => {
    // Implement save logic here
    setIsEditing(false)
  }

  const handleCancelClick = () => {
    setIsEditing(false)
  }

  return (
    <>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
        style={{zIndex: 9999}}
      />
      <div className='patient-details-container'>
        <div className='patient-card'>
          <div className='patient-info-grid'>
            {/* Card Number */}
            <div className='info-item'>
              <div className='info-label'>
                <FaIdCard className='info-icon' />
                <label>Nomor Kartu</label>
              </div>
              <div className='info-value'>{claimDetails?.claimDetails?.cardNumber || '-'}</div>
            </div>

            {/* Patient Name */}
            <div className='info-item'>
              <div className='info-label'>
                <FaUser className='info-icon' />
                <label>Nama Pasien</label>
              </div>
              <div className='info-value'>{claimDetails?.claimDetails?.memberName || '-'}</div>
            </div>

            {/* Claim Number */}
            <div className='info-item'>
              <div className='info-label'>
                <FaFileAlt className='info-icon' />
                <label>Nomor Klaim</label>
              </div>
              <div className='info-value'>{claimDetails?.claimDetails?.claimNumber || '-'}</div>
            </div>

            {/* Patient Status */}
            <div className='info-item'>
              <div className='info-label'>
                <FaUserCheck className='info-icon' />
                <label>Status Pasien</label>
              </div>
              <div className='info-value'>
                {parsedJson?.MemberStatus === true ? (
                  <span className='status-badge active'>Aktif</span>
                ) : (
                  <span className='status-badge'>{parsedJson?.MemberStatus || '-'}</span>
                )}
              </div>
            </div>

            {/* Patient Plan */}
            <div className='info-item'>
              <div className='info-label'>
                <FaHospitalUser className='info-icon' />
                <label>Plan Pasien</label>
              </div>
              <div className='info-value'>{parsedJson?.PlanName || '-'}</div>
            </div>

            {/* Date of Birth */}
            <div className='info-item'>
              <div className='info-label'>
                <FaBirthdayCake className='info-icon' />
                <label>Tanggal Lahir</label>
              </div>
              <div className='info-value'>{calculateAge(parsedJson?.DateOfBirth)}</div>
            </div>

            {/* Gender */}
            <div className='info-item'>
              <div className='info-label'>
                <FaVenusMars className='info-icon' />
                <label>Jenis Kelamin</label>
              </div>
              <div className='info-value'>{parsedJson?.Gender === 'M' ? 'Laki-laki' : 'Perempuan'}</div>
            </div>

            {/* Company Name */}
            <div className='info-item'>
              <div className='info-label'>
                <FaBuilding className='info-icon' />
                <label>Nama Perusahaan</label>
              </div>
              <div className='info-value'>{parsedJson?.InsurerName || '-'}</div>
            </div>

            {/* Join Date */}
            <div className='info-item'>
              <div className='info-label'>
                <FaCalendarAlt className='info-icon' />
                <label>Tanggal Bergabung</label>
              </div>
              <div className='info-value'>
                {parsedJson?.JoinDate
                  ? new Date(parsedJson.JoinDate).toLocaleDateString('id-ID')
                  : '-'}
              </div>
            </div>

            {/* Special Notes */}
            <div className='info-item full-width'>
              <div className='info-label'>
                <FaStickyNote className='info-icon' />
                <label>Catatan Khusus</label>
              </div>
              <div className='info-value'>{parsedJson?.Remark || '-'}</div>
            </div>

            {/* Document */}
            <div className='info-item full-width'>
              <div className='info-label'>
                <FaFile className='info-icon' />
                <label>Dokumen</label>
              </div>
              <div className='info-value'>
                <span
                  onClick={() => setShowDocModal(true)}
                  style={{
                    cursor: 'pointer',
                    color: '#059BB6',
                    textDecoration: 'underline',
                  }}
                >
                  Lihat Dokumen Registrasi
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Document Modal */}
      <Modal show={showDocModal} onHide={() => setShowDocModal(false)} size='xl' centered>
        <Modal.Header closeButton>
          <Modal.Title>Dokumen Registrasi</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{padding: 0, height: 'calc(90vh - 120px)'}}>
          <iframe
            src={`https://docs.google.com/viewer?url=${encodeURIComponent(
              claimDetails?.claimDetails?.urlRegisterForm
            )}&embedded=true`}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
            title='Register Form Preview'
            frameBorder='0'
          />
        </Modal.Body>
      </Modal>

      <style>
        {`
                    .patient-details-container {
                        padding: 24px;
                        max-width: 100%;
                        margin: 0 auto;
                    }

                    .patient-card {
                        background: white;
                        border-radius: 12px;
                        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
                        padding: 24px;
                        transition: all 0.3s ease;
                        margin: 0 -8px;
                    }

                    .patient-info-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 20px;
                    }

                    .info-item {
                        padding: 20px;
                        background: #f8f9fa;
                        border-radius: 10px;
                        transition: all 0.2s ease;
                        min-width: 200px;
                        min-height: 100px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }

                    .info-item:hover {
                        background: #fff;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                        transform: translateY(-2px);
                    }

                    .info-item.full-width {
                        grid-column: 1 / -1;
                        min-height: 120px;
                    }

                    .info-label {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        margin-bottom: 12px;
                    }

                    .info-label label {
                        color: #6c757d;
                        font-size: 0.9rem;
                        font-weight: 500;
                        margin: 0;
                    }

                    .info-icon {
                        color: #059BB6;
                        font-size: 1.1rem;
                    }

                    .info-value {
                        color: #2c3e50;
                        font-size: 1rem;
                        font-weight: 500;
                        line-height: 1.5;
                    }

                    .status-badge {
                        display: inline-flex;
                        align-items: center;
                        padding: 8px 16px;
                        border-radius: 20px;
                        font-size: 0.9rem;
                        font-weight: 500;
                        background: #e9ecef;
                        color: #495057;
                    }

                    .status-badge.active {
                        background: rgba(4, 180, 64, 0.1);
                        color: #04B440;
                    }

                    @media (max-width: 1400px) {
                        .patient-info-grid {
                            grid-template-columns: repeat(3, 1fr);
                        }
                    }

                    @media (max-width: 1100px) {
                        .patient-info-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }

                    @media (max-width: 768px) {
                        .patient-details-container {
                            padding: 16px;
                        }

                        .patient-card {
                            padding: 20px;
                            margin: 0;
                        }

                        .patient-info-grid {
                            grid-template-columns: 1fr;
                            gap: 16px;
                        }

                        .info-item {
                            padding: 16px;
                            min-width: unset;
                            min-height: 90px;
                        }

                        .info-item.full-width {
                            min-height: 100px;
                        }

                        .info-label {
                            margin-bottom: 10px;
                        }

                        .info-label label {
                            font-size: 0.875rem;
                        }

                        .info-value {
                            font-size: 0.95rem;
                        }

                        .status-badge {
                            padding: 6px 12px;
                            font-size: 0.875rem;
                        }
                    }
                `}
      </style>
    </>
  )
}

export default PatientDetails
